module.exports = __webpack_public_path__ + "static/media/stitching.d0254977.mp4";